import {combineReducers} from 'redux'
import types from 'actions/types'

export const showDormants = (state = false, action) => {
  switch (action.type) {
    case types.SETTINGS_TEAMS_TOGGLE_DORMANTS:
      return !state
    default:
      return state
  }
}

export const expandedTeamIds = (state = [], action) => {
  switch (action.type) {
    case types.SETTINGS_EXPAND_TEAM:
      return [
        ...state,
        action.teamId,
      ]
    case types.SETTINGS_COLLAPSE_TEAM:
      return state.filter(expandedTeamId => expandedTeamId !== action.teamId)
    default:
      return state
  }
}

export default combineReducers({
  expandedTeamIds,
  showDormants,
})
